import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['../auth-layout/auth-layout.component.css'],
})
export class FooterComponent implements OnInit {
	constructor() {}

	ngOnInit() {}
}
